import {
  observable,
  action,
  decorate,
  configure,
  toJS,
  runInAction,
} from 'mobx';
import reducer from './reducers/members';
import { loadData, toBoolean } from './utils';
import { API_REGISTEREDBIDDER_UPDATE_ENDPOINT as registeredMembersUrl } from './../shared/constants/';

configure({ enforceActions: 'always' });

class MembersStore {
  constructor() {
    runInAction(() => {
      this.data = [];
      this.totalItems = 0;
      this.isLoading = true;
      this.debugging = false;
      this.memberTypes = ['UNIQUE', 'REGISTERED', 'AUTHORIZED'];
    });
  }

  setProperty = (key, value) => {
    this[key] = value;
  };

  getProperty = (key) => {
    return this[key];
  };

  finalizeResults = ({ data, totalItems }) => {
    this.setProperty('data', toJS(data));
    this.setProperty('totalItems', totalItems);
    this.setProperty('isLoading', false);

    if (this.debugging) {
      console.log('finalizeResults', {
        data: toJS(this.getProperty('data')),
        totalItems: this.getProperty('totalItems'),
        isLoading: this.getProperty('isLoading'),
      });
    }
  };

  getMembers = async (
    auctionID,
    pageNumber,
    pageSize,
    searchText,
    sortColumn,
    sortDirection,
    memberState,
    memberType,
    debugging = false,
  ) => {
    if (!auctionID) {
      return;
    }

    const params = {
      auctionID,
      pageSize,
      name: searchText[0]?.searchValue,
      pageNumber,
      sortBy: sortColumn,
      sortDirection,
      status: memberState,
    };

    this.debugging = debugging;
    this.isLoading = true;
    const { fn, processData } = reducer(memberType);
    // FIXME: totalItems is broken in API when pulling enabled authorized members
    loadData(params, fn).then(processData).then(this.finalizeResults);
  };

  updateMemberState = async (
    authorizedMemberID,
    enableRegisteredBidderFlag,
    member,
  ) => {
    // console.log('updateMemberState', {
    //   authorizedMemberID,
    //   enableRegisteredBidderFlag,
    //   member,
    // });
    if (this.debugging)
      console.log('updateMemberState', {
        authorizedMemberID,
        enableRegisteredBidderFlag,
        member,
      });
    const toggleEnableFlag = enableRegisteredBidderFlag ? 0 : 1;
    const res = await loadData(
      {
        authorizedMemberID,
        enableRegisteredBidderFlag: toBoolean(toggleEnableFlag),
      },
      registeredMembersUrl,
    );
    return {
      authorizedMemberID,
      member,
      disableBidder: enableRegisteredBidderFlag === 0,
      res,
    };
  };
}

decorate(MembersStore, {
  data: observable,
  debugging: observable,
  finalizeResults: action,
  getMembers: action,
  getProperty: action,
  initializeMembersList: action,
  isLoading: observable,
  memberTypes: observable,
  reducer: action,
  setData: action,
  setProperty: action,
  totalItems: observable,
  updateMemberState: action,
});

export default MembersStore;
